<script setup>
// Knowledge with no portal yet (K1, phase 6.1): the kit's HelpEmptyState. Behind the words, faded, three rows of
// the article table this area will show (D-G5 keeps the faded preview), with the woot's sample articles.
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import HelpEmptyState from 'dashboard/components-next/polaris/cards/HelpEmptyState.vue';
import CreatePortalDialog from 'dashboard/components-next/HelpCenter/PortalSwitcher/CreatePortalDialog.vue';
import ArticlePreviewRows from 'dashboard/components-next/HelpCenter/EmptyState/Article/ArticlePreviewRows.vue';

const { t } = useI18n();
const router = useRouter();

const createPortalDialogRef = ref(null);
const openDialog = () => {
  createPortalDialogRef.value.dialogRef.open();
};

const onPortalCreate = ({ slug: portalSlug, locale }) => {
  router.push({
    name: 'portals_articles_index',
    params: { portalSlug, locale },
  });
};
</script>

<template>
  <div class="w-full max-w-3xl mx-auto">
    <HelpEmptyState
      :title="t('HELP_CENTER.TITLE')"
      :description="t('HELP_CENTER.NEW_PAGE.DESCRIPTION')"
      :action-label="t('HELP_CENTER.NEW_PAGE.CREATE_PORTAL_BUTTON')"
      @action="openDialog"
    >
      <template #preview>
        <ArticlePreviewRows />
      </template>
    </HelpEmptyState>
    <CreatePortalDialog ref="createPortalDialogRef" @create="onPortalCreate" />
  </div>
</template>
